// extracted by mini-css-extract-plugin
export var dataCell = "_ps-2";
export var dataRow = "_ps-0";
export var headerRow = "_ps-1";